import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { bubbleSx, containerSx, tailSx } from '../styles';

type ChatMessageWrapperProps = {
  children: ReactNode;
  isUser: boolean;
  showTail: boolean;
  isFullWidth?: boolean;
};

export const ChatMessageWrapper = ({ children, isUser, showTail, isFullWidth = false }: ChatMessageWrapperProps) => {
  return (
    <Box data-test={isUser ? 'user-message' : 'agent-message'} sx={containerSx(isUser)}>
      <Box sx={bubbleSx(isUser, isFullWidth)}>{children}</Box>

      {showTail && <Box sx={tailSx(isUser)} />}
    </Box>
  );
};
